// Turn any value type into a string consistently
// note: this used to be imported in places using a default export and named "deterministic-string", but now is toString
export var toString = function toString(anyValue) {
  if (typeof anyValue === "string") {
    return anyValue.replace(/[~,*{}[\]]/g, function (m) {
      return "~" + m;
    });
  }

  if (typeof anyValue === "undefined") {
    return "*u";
  }

  if (anyValue === null) {
    return "*n";
  }

  if (Array.isArray(anyValue)) {
    return "[" + anyValue.map(toString).join() + "]";
  }

  if (typeof anyValue === "object") {
    return "{" + Object.entries(anyValue).sort(function (_ref, _ref2) {
      var aKey = _ref[0];
      var bKey = _ref2[0];
      return bKey.localeCompare(aKey);
    }).reduce(function (acc, entry) {
      return [].concat(acc, entry);
    }, []).map(toString).join() + "}";
  }

  return "*" + String(anyValue);
};